import React from 'react'
import './organic_performance_card.css'
import { IoArrowUp } from "react-icons/io5";
import { FiHeart } from "react-icons/fi";
import { BiComment } from "react-icons/bi";
import { IoShareSocialOutline } from "react-icons/io5";
import { HiOutlineBookmark } from "react-icons/hi2";
import { LuVideo } from "react-icons/lu";
import { AiOutlineEye } from "react-icons/ai";
import { IoMdLink } from "react-icons/io";
import { LuClock4 } from "react-icons/lu";
import LeadsBarChart from '../../LeadsBarChart';
import { getImgSrc } from '../../../../../helpers/getImgSrc';
import {getSvgIcons} from '../../../../../helpers/getReactIcons.js'
import { useNavigate } from 'react-router-dom';

const OrganicPerformanceCard = ({heading,heading_icon="refresh",
    metrics,
    reach_impressions_metrics,
    engagement_overview_metrics,
    content_performance_metrics,
    card_styles,
    bar_graph_data

}) => {

  const navigate=useNavigate()

  const top_Performing_post_bar_graph=[
    {
        label: 'Engagement Rate (%)',
        backgroundColor:bar_graph_data?.backgroundColor ?? '#D3A4FF', 
        borderColor:bar_graph_data?.borderColor ?? '#D3A4FF',
        borderWidth: 1,
        data: content_performance_metrics?.top_performing_posts?.map((post_data)=>post_data?.engagement)
    },

  
]

const handleNavigation=(post_data)=>{
  try{
   
    if(post_data?.post_id && post_data?.platform_id)
    {
      navigate(`/client/organic-social/view-more/${post_data?.post_id}/${post_data?.platform_id}`)
    }

  }catch(e)
  {
    console.log(e)
  }
}


   
  return (
    <div className="organic_social_connected_accounts_wrapper">
          <div className="organic_social_connected_accounts_wrapper_border" style={{backgroundColor:card_styles?.card_border_color}}>

          </div>
          <div className="organic_social_connected_accounts_wrapper_top">
            <div className='organic_social_connected_accounts_wrapper_top_heading' >
              <div className={`organic_social_connected_accounts_wrapper_top_logo ${card_styles?.card_background_color_class}`} >
                <img src={getImgSrc(heading_icon)} alt="" />
              </div>
              <div className='organic_social_connected_accounts_wrapper_top_heading_text'>
                <h3 className=''>{heading}</h3>
                <span></span>
              </div>


            </div>

          </div>
          <div className="organic_social_connected_accounts_wrapper_bottom">
            <div className={`organic_social_connected_accounts_wrapper_bottom_top_container `}>
              <div className={`organic_social_metrics_container ${card_styles?.card_background_color_class}`}>
                <h4>Impressions & Engagement </h4>
                <div className='organic_social_metrics_card_container'>
                    {reach_impressions_metrics?.length>0 && reach_impressions_metrics?.map((data)=>{
                        return  <div className='organic_social_metrics_card'>
                        <p>{data?.metric_name}</p>
                        <h4>{Number(String(data?.value ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</h4>
                        {data?.increment && 
                        <div className='d-flex gap-1 align-items-center'>
                          {/* <IoArrowUp />
                          <span>{data?.increment} vs. previous period</span> */}
                        </div>}
    
                      </div>
                    })}
         
            

                </div>


              </div>
              <div className={`organic_social_engagement_overview_container ${card_styles?.card_background_color_class} `}>
                <h4>Engagement Overview</h4>
                <div className='organic_social_engagement_overview_card_container'>
                  {/* <div className="organic_social_engagement_overview_card_container_top"> 
                    <div className='organic_social_engagement_overview_card'>
                      <p>Total Engagement Rate</p>
                       <h4>{engagement_overview_metrics?.total_engagement_rate?.value ?? '0%'}</h4>
                    </div>

                  </div> */}
                  <div className="organic_social_engagement_overview_card_container_bottom">
                    <div className='organic_social_engagement_overview_metrics_card'>
                       <div>
                      {engagement_overview_metrics?.reactions?.icon}
                       </div>
                       <p>reactions</p>
                      <h5> {Number(String(engagement_overview_metrics?.reactions?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")} </h5>
                    </div>
                    <div className='organic_social_engagement_overview_metrics_card'>
                       <div>
                       {engagement_overview_metrics?.comments?.icon}
                       </div>
                       <p>comments</p>
                      <h5>{Number(String(engagement_overview_metrics?.comments?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</h5>
                    </div>
                    <div className='organic_social_engagement_overview_metrics_card'>
                       <div>
                       {engagement_overview_metrics?.shares?.icon}
                       </div>
                       <p>shares</p>
                      <h5>{Number(String(engagement_overview_metrics?.shares?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</h5>
                    </div>
                    <div className='organic_social_engagement_overview_metrics_card'>
                       <div>
                       {engagement_overview_metrics?.saves?.icon}
                       </div>
                       <p>saves</p>
                      <h5> {Number(String(engagement_overview_metrics?.saves?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</h5>
                    </div>
                    
                  </div>
               

                </div>


              </div>

            </div>
            <div className="organic_social_connected_accounts_wrapper_bottom_bottom_container">

              <div className={`top_container ${card_styles?.card_background_color_class}`} >
                <h4>Content Performance</h4>
                 <div className='top_container_content'>
                  {/* graph */}
                  <div className='top_container_content_graph'>
                    <h4>Post Type Performance</h4>
                    <div className='top_container_content_graph_container'>
                         <LeadsBarChart 
                          bar_graph_data={top_Performing_post_bar_graph}
                          labels={content_performance_metrics?.top_performing_posts?.map((post,index)=>'Post '+(index+1))}
                         
                         
                         />
                    </div>

                  </div>
                  {/* top performing posts */}
                  <div className='top_container_content_top_performing_posts' >
                    <h4>Top Performing Posts</h4>
                     <div className='top_container_content_top_performing_posts_card_container'>
                        {content_performance_metrics?.top_performing_posts?.length>0 && content_performance_metrics?.top_performing_posts?.map((post_data)=>{
                            return  <div className='top_performing_posts_card' 
                            style={{cursor:'pointer'}} 
                            onClick={()=>handleNavigation(post_data)}
                            >
                            <div className='top_performing_posts_card_top'>
                              {post_data?.post_icon}
                              <p>{post_data?.message}</p>
                            </div>
                             <div className='top_performing_posts_card_bottom'>
                              <span>Engagement: {Number(String(post_data?.engagement).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>
                              {/* <span>Date:{post_data?.date}</span> */}
                            </div>
  
                          </div>
                        })}
                   
                        

                    </div>

                   </div>

                 </div>

              </div>
              <div className="bottom_container">
              {metrics?.length>0 && metrics?.map((metric)=>{
                       return <div className={`organic_social_metrics_container  ${card_styles?.card_background_color_class}`}>
                       <h4>{metric?.heading}</h4>
                       <div className='organic_social_metrics_card_container'>
                         {metric?.data?.length>0 && metric?.data?.map((metric_data)=>{
                          return    <div className='organic_social_metrics_card'>
                            <div className='organic_social_metrics_card_heading'>
                              {metric_data?.metric_icon &&    <p style={{width:'1rem',aspectRatio:'1/1'}}>{metric_data?.metric_icon}</p>}
                              <p>{metric_data?.metric_name}</p>
                            </div>
                         
                          <h4>{Number(String(metric_data?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</h4>
                          {metric_data?.increment && 
                          <div className='d-flex gap-1 align-items-center'>
                            <IoArrowUp />
                            <span>{metric_data?.increment} vs. previous period</span>
                          </div>}
      
                        </div>
                         }) }
                      
                     
       
                       </div>
       
       
                     </div>

              })}

       

              </div>






            </div>


          </div>

        </div>
  )
}

export default OrganicPerformanceCard